import { useEffect, useRef, useState } from "react";
import style from "./TermSelect.module.scss";
import cn from "classnames";
import { ITariff } from "@interfaces/user/tariff";

export function TermSelect({
    value,
    listTerms,
    setValue
}: {
    value: number,
    listTerms: ITariff["rental_periods"],
    setValue: (newValue: ITariff["rental_periods"][0]) => void
}) {
    const refContainer = useRef<HTMLDivElement | null>(null);

    const [isOpen, setIsOpen] = useState<boolean>(false);

    useEffect(() => {
        function handleClick(e: any) {
            if (!refContainer.current?.contains(e.target)) {
                setIsOpen(false);
            }
        }

        document.documentElement.addEventListener("click", handleClick);

        return () => {
            document.documentElement.removeEventListener("click", handleClick);
        };
    }, []);

    return (
        <div ref={refContainer} className="relative max-w-[52%] w-[52%] min-w-0">
            <div
                className={style.container}
                onClick={() => {
                    setIsOpen(state => !state)
                }}
            >
                <p className={style.label}>Термін:</p>
                <p className={style.selectValue}>{value}</p>
                <svg className={cn("shrink-0 select-none cursor-pointer", isOpen && "rotate-180")} xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
                    <path d="M5.46967 6.53033C5.76256 6.82322 6.23744 6.82322 6.53033 6.53033L11.3033 1.75736C11.5962 1.46447 11.5962 0.989592 11.3033 0.696699C11.0104 0.403806 10.5355 0.403806 10.2426 0.696699L6 4.93934L1.75736 0.696699C1.46447 0.403806 0.989592 0.403806 0.696699 0.696699C0.403806 0.989593 0.403806 1.46447 0.696699 1.75736L5.46967 6.53033ZM5.25 5L5.25 6L6.75 6L6.75 5L5.25 5Z" fill="#838199" />
                </svg>
            </div>
            <div className={cn(style.listValues, isOpen && style.listValues_open)}>
                {
                    listTerms.map(item => (
                        <div
                            key={item.id}
                            className={style.value}
                            onClick={() => {
                                setValue(item)
                                setIsOpen(false);
                            }}
                        >
                            {item.rent_time} {item.rent_time === 3 ? "дня" : "днів"}
                        </div>
                    ))
                }
            </div>
        </div>
    )
}